export enum StudentProgressExportStatusEnum {
  Running = 'running',
  Success = 'success',
  Failed = 'failed',
}
